<template>
  <b-modal ref="CreateSalesInvoiceModal" @shown="shown"
           :no-close-on-backdrop="true" :no-enforce-focus="true" @hidden="clearSalesInvoiceData">
    <div slot="modal-title">
      <div class="d-flex">
        <h5 class="modal-title">
          {{title}}
        </h5>
      </div>
    </div>
    <div>
      <b-row>
        <b-col class="d-flex align-items-center" cols="3">
          <label>{{$t('labels.common.order')}}</label>
        </b-col>
        <b-col cols="9">
          <multiselect v-model="salesInvoiceData.salesOrders" :max-height="200"
                       label="descriptor" track-by="id"
                       :options="salesOrders" :multiple="true"
                       :close-on-select="false"></multiselect>
        </b-col>
      </b-row>
      <b-row v-if="isCommissionerOrService">
        <b-col class="d-flex align-items-center" cols="3">
          <label>{{$t('labels.common.commissioner_service')}}</label>
        </b-col>
        <b-col cols="9">
          <multiselect v-model="salesInvoiceData.partner" :max-height="200"
                       label="name" track-by="name"
                       :options="partners" :multiple="false"
                       :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-center" cols="3">
          <label for="dicount">{{$t('labels.common.discount_proc')}}</label>
        </b-col>
        <b-col cols="9">
          <input id="dicount" type="checkbox" v-model="isDiscounted">
        </b-col>
      </b-row>
      <b-row v-if="isDiscounted">
        <b-col class="d-flex align-items-center" cols="3">
          <label>{{$t('labels.common.discount_value')}}</label>
        </b-col>
        <b-col cols="9">
          <input class="form-control" v-replace-with-negative-and-digits-decimal="{numberOfDigits: 3}"
                 v-model="discount_value">
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 d-flex justify-content-center align-items-center">
      <b-btn size="sm" class="ml-2" variant="success" @click="createInvoice"
             title="Create invoice" :disabled="isEmptyOrders || isEmptyPartner">
        {{$t('buttons.common.create')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';

  import { getArrayByProperty, handlerResponse } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { COMMISSION, SERVICE } from '@/constants/invoiceTypes';

  export default {
    props: ['data'],
    components: {
      Multiselect
    },
    data() {
      return {
        isDiscounted: false,
        discount_value: '',
        initialSalesInvoiceData: {
          salesOrders: [],
          partner: {}
        },
        salesInvoiceData: {}
      }
    },
    computed: {
      ...mapState('partners', ['partners']),
      ...mapState('woodware', ['salesOrders']),
      title() {
        return this.data.title;
      },
      isCommissionerOrService() {
        return this.data.isCouple;
      },
      invoiceType() {
        return this.data.type;
      },
      isEmptyOrders() {
        return this.salesInvoiceData && this.salesInvoiceData.salesOrders && this.salesInvoiceData.salesOrders.length === 0;
      },
      isEmptyPartner() {
        return (this.invoiceType === COMMISSION || this.invoiceType === SERVICE) && Object.keys(this.salesInvoiceData.partner).length === 0;
      }
    },
    methods: {
      shown() {
        this.isDiscounted = false;
        this.discount_value = '';
        this.salesInvoiceData = {
          salesOrders: [],
          partner: {}
        }
      },
      prepareInvoiceData() {
        return {
          additional_partner_id: (this.invoiceType === COMMISSION || this.invoiceType === SERVICE) ? this.salesInvoiceData.partner.id : null,
          create_discount_invoice: this.isDiscounted,
          discount_invoice_value: Math.abs(+this.discount_value),
          invoicing_type: this.invoiceType,
          sales_orders_id: getArrayByProperty(this.salesInvoiceData.salesOrders, 'id')
        };
      },
      createInvoice() {
        const invoiceData = this.prepareInvoiceData();
        this.$http.post('accounting/invoices/create_invoice_to_sales_orders/', invoiceData).then(handlerResponse).then((response) => {
          this.$router.push({path: `/sales-invoice/${response.id}`});
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      clearSalesInvoiceData() {
        this.salesInvoiceData = {...this.initialSalesInvoiceData};
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('woodware/loadSalesOrders');
      this.$store.cache.dispatch('partners/loadPartners');
    },
    mounted() {
      this.$root.$on('openCreateSalesInvoiceModal', _ => {
        if (this.$refs['CreateSalesInvoiceModal']) {
          this.salesInvoiceData = {...this.initialSalesInvoiceData};
          this.$refs['CreateSalesInvoiceModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openCreateSalesInvoiceModal');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/CreateSalesInvoiceModal.vue